<button class="oph-select-menu-item" [class.selected]="isSelected" (click)="buttonClick.emit()">
  <div #menuItems class="menu-item-container">
    @if (project.isChallenge) {
      <img src="assets/img/icons/projects-challenge.svg" alt="" />
    } @else {
      <div class="project-color" [style.background-color]="project.color"></div>
    }
    <span class="project-display">{{ project.label || 'UNTITLED' }}</span>
  </div>
</button>
